const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const resolveApiBase = () => {
  // Check for explicit environment variable first
  const configured = ((import.meta as any).env?.VITE_API_BASE_URL as string | undefined);
  
  if (typeof configured === 'string' && configured.trim()) {
    return trimTrailingSlash(configured.trim());
  }

  if (typeof window !== 'undefined' && window.location) {
    // Use Vite's DEV flag directly - always use port 3001 in development
    if ((import.meta as any).env?.DEV) {
      const host = window.location.hostname || '127.0.0.1';
      return `http://${host}:3001`;
    }
    // In production, use relative URLs so requests go to the same origin.
    // IIS (or any reverse proxy) is expected to forward /api and /auth to Node on port 3001.
    // This avoids cross-origin blocks when accessing via any hostname/domain.
    return '';
  }

  // Fallback: relative URLs
  return '';
};

export const API_BASE = resolveApiBase();
